import { render, staticRenderFns } from "./subjects-of-allegation-other.vue?vue&type=template&id=3ba66a51&scoped=true"
import script from "./subjects-of-allegation-other.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation-other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba66a51",
  null
  
)

export default component.exports